import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Label } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import DropdownItem from '@/components/DropdownItem';
import { updateRolePermissions } from '../actions';

const PermissionsTools = ({
  count,
  category,
  code,
  permissionCategories,
  direction = 'left',
  allowUpdate,
  enableAll,
  disableAll,
}) => (
  <Dropdown direction={direction} icon={<Label content={count} />}>
    <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
      {allowUpdate && (
        <DropdownItem
          textId="actions.enable.all"
          onClick={() => enableAll(category, code, permissionCategories)}
        />
      )}
      {allowUpdate && (
        <DropdownItem
          textId="actions.disable.all"
          onClick={() => disableAll(category, code, permissionCategories)}
        />
      )}
    </Dropdown.Menu>
  </Dropdown>
);

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  return ({ allowUpdate: update && !item.system });
};

const mapDispatchToProps = {
  enableAll: (category, code, permissionCategories) => (
    updateRolePermissions(category, code, permissionCategories, 'on')
  ),
  disableAll: (category, code, permissionCategories) => (
    updateRolePermissions(category, code, permissionCategories, 'off')
  ),
};

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsTools);
